import { useEffect } from "react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

/**
 * Toast unificado para TODAS las pantallas que consumen useDateRangeFilter.
 *
 * Mensaje traducible vía i18n. La clave es `dateFilter.adjustedTitle` y
 * está definida en es/en/fr/pt/ar. Si la clave no estuviera disponible
 * (idioma sin traducir / i18n no inicializado) se cae al literal en español
 * para mantener el comportamiento histórico.
 */
export const DATE_FILTER_ADJUSTED_KEY = "dateFilter.adjustedTitle";
export const DATE_FILTER_ADJUSTED_FALLBACK = "Filtro de fecha ajustado";

export function useDateRangeFallbackToast(reason: string | null) {
  const { t } = useTranslation();
  useEffect(() => {
    if (reason) {
      const title = t(DATE_FILTER_ADJUSTED_KEY, { defaultValue: DATE_FILTER_ADJUSTED_FALLBACK });
      // duration ampliada para dar tiempo a lectores de pantalla a anunciar
      // el mensaje (Sonner ya expone role="status" + aria-live="polite").
      toast.warning(title, {
        description: reason,
        duration: 6000,
      });
    }
  }, [reason, t]);
}
